module.exports = __webpack_public_path__ + "img/geod_17.881e2030.jpg";